export function useHttpErrorTexts(status) {
    const errorTitle = {
        503: "503: Service Unavailable",
        500: "500: Server Error",
        404: "404: Page Not Found",
        403: "403: Forbidden",
    }[status];

    const errorDescription = {
        503: "Förlåt, vi utför lite underhåll. Vänligen återkom snart.",
        500: "Hoppsan, något gick fel på våra servrar. Felet har automatiskt rapporterats till våra utvecklare.",
        404: "Sidan / resursen du letar efter kunde inte hittas.",
        403: "Du har inte behörighet att komma åt denna resurs / sida.",
    }[status];

    return {
        errorTitle,
        errorDescription,
    };
}
